import React, { useEffect, useReducer, useState } from "react";
import { Form, Toast, ToastContainer, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { axiosOpen } from "../../../api/axios";

const reducer = (state , action) => {
  switch (action.type) {
    case "name":
      return { ...state, name: action.payload };
    case "amount":
      return { ...state, amount: action.payload };
    case "currency":
      return { ...state, currency: action.payload };
    case "interval":
      return { ...state, interval: action.payload };
    case "description":
      return { ...state, description: action.payload };
  }
};

  const EditPlans = () => {
  const navigate = useNavigate();
  const [error, setError] = useState({
    isValid: true,
    name: "",
    amount: "",
    currency: "",
    interval: "",
    description: "",
  });
  const [dataLoader, setDataLoader] = useState(true);
  const [plan, setPlan] = useState(null);
  const { id } = useParams();
  const [state, dispatch] = useReducer(reducer, {
    name: "",
    amount: "",
    currency: "",
    interval: "",
    description: ""
  });
  
  const fetchPlanDetailsById = async () => {
    const response = await axiosOpen.get("/api/subscription/item/"+id);
    // console.log(response?.data);
    setPlan(response?.data);
    dispatch({ type: "name", payload: plan?.name });    
    dispatch({ type: "amount", payload: plan?.amount });    
    dispatch({ type: "currency", payload: plan?.currency });    
    dispatch({ type: "interval", payload: plan?.interval });    
    dispatch({ type: "description", payload: plan?.description });    
    setDataLoader(false);
  };
  useEffect(() => {
    fetchPlanDetailsById();
  }, [dataLoader]);
  const fieldsValidation = (state) => {
    let invalidForm = false;
    if (!state.name) {
      setError((err) => ({ ...err, name: "Field Required" }));
      invalidForm = true;
    } else {
      setError((err) => ({ ...err, name: "" }));
      invalidForm = false;
    }
    if (!state.amount) {
      setError((err) => ({ ...err, amount: "Field Required", isValid: false }));
      invalidForm = true;
    } else {
      setError((err) => ({ ...err, amount: "" }));
      invalidForm = false;
    }
    if (!state.currency) {
      setError((err) => ({ ...err, currency: "Field Required", isValid: false }));
      invalidForm = true;
    } else {
      setError((err) => ({ ...err, currency: "" }));
      invalidForm = false;
    }
    if (!state.interval) {
      setError((err) => ({ ...err, interval: "Field Required", isValid: false }));
      invalidForm = true;
    } else {
      setError((err) => ({ ...err, interval: "" }));
      invalidForm = false;
    }
    if (!state.description) {
      setError((err) => ({ ...err, description: "Field Required", isValid: false }));
      invalidForm = true;
    } else {
      setError((err) => ({ ...err, description: "" }));
      invalidForm = false;
    }
    // if (!state.email) {
    //   setError((err) => ({ ...err, email: "Field Required", isValid: false }));
    //   invalidForm = true;
    // } else {
    //   setError((err) => ({ ...err, email: "" }));
    //   invalidForm = false;
    // }
    return invalidForm;
  };

  const handleResetForm = () => {
    dispatch({ type: "name", payload: "" });
    dispatch({ type: "amount", payload: "" });
    dispatch({ type: "currency", payload: "" });
    dispatch({ type: "interval", payload: "" });
    dispatch({ type: "description", payload: "" });
    // dispatch({ type: "email", payload: "" });
  };

  const handleEditPlans = (e) => {
    e.preventDefault();
    if (fieldsValidation(state)) {
        console.log("invalid form")
      return;
    } else {
        
      const requestBody = {
        name: state.name,
        amount: state.amount,
        currency: state.currency,
        interval: state.interval,
        description: state.description
      };
      (async () => {
        try {
          await axiosOpen.post("", { ...requestBody });
          navigate("/plans");
        } catch (err) {
          console.log(err);
        }
      })();
    }
  };

  return (
 <>
 {dataLoader ? (<>
    <div className="d-flex justify-content-center align-items-center h-100">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
 
 </>) : (<>
    <div className="add-user-container">
      <Form onSubmit={handleEditPlans} className="add-user-form add-plans">
        <Form.Group className="mb-3" controlId="formBasicName">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Name"
            onChange={(e) => dispatch({ type: "name", payload: e.target.value })}
            isInvalid={error.name}
            value={ state.name}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicAmount">
          <Form.Label>Amount</Form.Label>
          <Form.Control
            type="number"
            placeholder="Amount"
            onChange={(e) => dispatch({ type: "amount", payload: e.target.value })}
            isInvalid={!!error.amount}
            value={state.amount}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicCurrency">
          <Form.Label>Currency</Form.Label>
          <Form.Control
            type="text"
            placeholder="Currency"
            onChange={(e) => dispatch({ type: "currency", payload: e.target.value })}
            isInvalid={!!error.currency}
            value={state.currency}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicInterval">
          <Form.Label>Interval</Form.Label>
          <Form.Control
            type="text"
            placeholder="Interval"
            onChange={(e) => dispatch({ type: "interval", payload: e.target.value })}
            isInvalid={!!error.interval}
            value={state.interval}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicDescription">
          <Form.Label>Description</Form.Label>
          <Form.Control
            type="textArea"
            placeholder="Description"
            onChange={(e) => dispatch({ type: "description", payload: e.target.value })}
            isInvalid={!!error.description}
            value={state.description}
          />
        </Form.Group>
        {/* <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Email"
            onChange={(e) => dispatch({ type: "email", payload: e.target.value })}
            isInvalid={!!error.email}
            value={state.email}
          />
        </Form.Group> */}
        <Button variant="primary" type="submit">
          Update
        </Button>
        <Button variant="secondary" onClick={handleResetForm}>
          Reset
        </Button>
      </Form>
    </div>
 </>
 )} 
 </>
    

  );
};

export default EditPlans;
